import request from '@/router/axios'
import {dealClearCode} from 'meibao-insure/src/util/commonUtils'
import store from '@/store'

export function fetchList(query) {
	return request({
		url: '/dist/distProduct/list',
		method: 'get',
		params: query,
	})
}

export function getProductList(query) {
	return request({
		url: '/dist/distProduct/listInfo',
		method: 'get',
		params: query,
	})
}

export function getProductPrice(query, insureType) {
	let headers = dealClearCode(insureType, store)
	return request({
		url: '/dist/distProduct/price',
		method: 'get',
		params: query,
		headers,
	})
}

export function getProfessionHistory(id, query) {
	return request({
		url: '/dist/distProduct/professHistory/' + id,
		method: 'get',
		params: query,
	})
}

//获取邮寄地址 /recipient/myList
export function getAddressMyList() {
	return request({
		url: '/dist/recipient/myList',
		method: 'get',
	})
}
